export default {
  requestsInProgress: 0,
  medications: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  allergies: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  vaccinations: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  medicalHistory: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  filters: {
    surname: null,
  },
  modals: {
    deleteVaccination: {
      visible: false,
      vaccinationId: null,
      vaccinationName: "",
    },
    addVaccination: {
      visible: false,
      vaccinationTypes: [],
    },
    addMedication: {
      visible: false,
    },
    addAllergy: {
      visible: false,
    },
    addMedicalHistoryItem: {
      visible: false,
    },
    removeMedication: {
      visible: false,
      medicationId: null,
    },
    removeAllergy: {
      visible: false,
      allergyId: null,
    },
    removeMedicalHistoryItem: {
      visible: false,
      medicalHistoryItemId: null,
    },
  },
  changelog: {
    requestsInProgress: 0,
    list: {
      content: [],
      pagination: {
        sort: { orders: [] },
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
      totalElements: 0,
    },
    schema: null,
  },
  schema: {
    medication: null,
    allergy: null,
    medicalHistory: null,
  },
};
